import { zTariffCommonSchema } from "./tariff.common";
export const zTariffSchemaDto = zTariffCommonSchema;
export const zTariffSchemaCreateDto = zTariffSchemaDto.omit({ id: true });
